import { AccordionDetails,Accordion,AccordionSummary, CircularProgress, Grid } from "@mui/material";
import * as S from "./styles";
import { FaAngleDown, FaMoneyBill } from "react-icons/fa6";
import { fetchGetTickets } from "@/hooks/fetchHooks/adminFetch";
import * as dateFns from "date-fns";
import { useMemo } from "react";
import { PiSoccerBall } from "react-icons/pi";
import { BsCircle, BsCircleFill, BsLink, BsShop } from "react-icons/bs";
import { BiCalendar, BiDollar, BiMoney, BiMoneyWithdraw } from "react-icons/bi";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
import {
  TbCurrencyDollarOff,
  TbCurrencyKip,
  TbSoccerField,
} from "react-icons/tb";
import { CalendarIcon } from "@mui/x-date-pickers";

export default function UserTickets() {
  const allTickets = fetchGetTickets();
  const ticketsBets = useMemo(() => {
    return allTickets.data?.reduce((accumulator, currentValue) => {
      const existingBetName = accumulator.find(
        (item) => item.value === currentValue.betName
      );
      if (!existingBetName) {
        accumulator.push({
          value: currentValue.betName,
          label: currentValue.betName,
        });
      }
      return accumulator;
    }, [] as { value: string; label: string }[]);
  }, [allTickets.data]);

  

  return (
    <S.WrapperTickets>
      {allTickets.isLoading ? (
        <Grid container justifyContent="center">
          <CircularProgress />
        </Grid>
      ) : ticketsBets ? (
        ticketsBets.map((key, i) => (
          <S.StyledAccordion key={`${key}-${i}`} sx={{ mb: 2 }}>
            <S.StyledAccordionSummary
              expandIcon={<FaAngleDown />}
              aria-controls={`panel${key.label}-${i}-content`}
              id={`panel${key.label}-${i}`}
            >
              <S.HeaderCont>
                <PiSoccerBall />
                {key.value}
              </S.HeaderCont>
            </S.StyledAccordionSummary>
            <S.StyledAccordionDetails
              sx={(props) => ({
                backgroundColor: props.palette.backgroundColor.main,
              })}
            >
              <Grid container spacing={2}>
                {allTickets.data
                  ?.filter((el) => el.betName === key.value)
                  .map((el) => (
                    <Grid item md={allTickets.data.length >= 3 ? 4: true} xs={12}>
                      {/* @ts-ignore */}
                      <Accordion>
                          {/* @ts-ignore */}
                        <AccordionSummary
                          expandIcon={<FaAngleDown />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <S.HeaderCont>
                            <p>
                              <div className="green-circle"></div>
                              {el.event}
                            </p>
                            <span>{el.odd}</span>
                          </S.HeaderCont>
                            {/* @ts-ignore */}
                        </AccordionSummary>
                        <AccordionDetails>
                          <S.DetailsCont>
                            <p>
                              <TbSoccerField /> {el.team1} vs {el.team2}
                            </p>
                            <p className="type-bet">
                              {" "}
                              <BsShop /> Mercado: {el.betType}
                            </p>
                            <p>
                              {" "}
                              <BiMoneyWithdraw />
                              Valor da bet: {el.betValue}
                            </p>
                            <p>
                              <BiCalendar />
                              Dia da partida:{" "}
                              {dateFns.format(
                                dateFns.parseISO(el.matchDate.toString()),
                                "dd/MM/yyyy"
                              )}
                            </p>
                            <div className="btn-container">
                              <a href={el.linkUrl} target="_blank">
                                <BsLink />
                                Link da aposta
                              </a>
                            </div>
                          </S.DetailsCont>
                        </AccordionDetails>
                          {/* @ts-ignore */}
                      </Accordion>
                    </Grid>
                  ))}
              </Grid>
            </S.StyledAccordionDetails>
          </S.StyledAccordion>
        ))
      ) : (
        <></>
      )}
    </S.WrapperTickets>
  );
}
